export const RecentComplaintsCard = ({ title, complaints, onOpen }) => {
  return (
    <div className="card" data-testid="recent-complaints-card">
      <div className="card-head">
        <h3>{title}</h3>
      </div>
      <div className="card-body card-body-flat">
        {complaints.length === 0 ? (
          <div className="empty-state" data-testid="recent-empty-state">No records available</div>
        ) : (
          complaints.map((item) => (
            <button
              key={item.complaint_id}
              className="complaint-row"
              onClick={() => onOpen(item.complaint_id)}
              data-testid={`recent-row-${item.complaint_id}`}
            >
              <span className="comp-id">{item.complaint_id}</span>
              <span className="comp-title">{item.category}</span>
              <span className={`status-pill ${item.statusClass || "sp-pend"}`}>{item.status}</span>
              <span className="comp-date">{item.dateLabel}</span>
            </button>
          ))
        )}
      </div>
    </div>
  );
};
